export const CUSTOMER_INVOICES_FLAGS = {
	SAFETY: 'safety',
	BILLING: 'billing',
	BILLING_OLD: 'billingOld',
	DISPATCH: 'dispatch',
	DISPATCH_OLD: 'dispatchOld',
	ADDITIONAL: 'additional',
};
